import { render } from "./Shinseisyolist.vue?vue&type=template&id=e8f5b688&ts=true"
import script from "./Shinseisyolist.vue?vue&type=script&lang=ts"
export * from "./Shinseisyolist.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__